import React from "react";
import { FaDolly, FaRedo, FaDollarSign } from "react-icons/fa";

export const servicesData = [
    {
        id: 1,
        icon: <FaDolly />,
        title: "free shipping",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus."
      },
      {
        id: 2,
        icon: <FaRedo />,
        title: "30 days return policy",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus."
      },
      {
        id: 3,
        icon: <FaDollarSign />,
        title: "secured payment",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus."
      }
  ]
